import { Drawer, SimpleToolbar, Toast, Loader } from "../../components";
import { AuthContext } from "../../context";
import { useDrawer } from "../../hooks";
import { useState, useEffect, useContext } from "react";
import {
  Container,
  Typography,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  makeStyles,
  Box,
  Tooltip,
  Icon,
  Hidden,
  Button,
  Menu,
  MenuItem,
  IconButton,
} from "@material-ui/core";
import {
  Visibility,
  CreateOutlined,
  ScheduleRounded,
  CloudDownloadRounded,
} from "@material-ui/icons";
import moment from "moment";
import PostAddOutlinedIcon from "@material-ui/icons/PostAddOutlined";
import { laboratoryServices } from "../../services";
import { CustomTable } from "../../components/custom-table";
import LinkButton from "../../components/link-button";
import ConsentsSearchBar from "../../components/consents-search-bar";

export const consentsCaption = {
  type: {
    ASSIGNMENT: "Asignación",
    REGISTER: "Registro",
  },
  target: {
    ORDERS_DOCTORS: "Órdenes de médicos",
    ORDERS_PATIENTS: "Órdenes de pacientes",
    DOCTORS: "Médicos",
  },
};
export default function ConsentScreen() {
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [reportLoading, setReportLoading] = useState(false);
  const { isOpen, setIsOpen } = useDrawer();
  const classes = useStyles();
  const { authState } = useContext(AuthContext);
  const [listInformedConsents, setListInformedConsents] = useState(null);
  const isMasterAdmin = authState.user.role._id === "5fdb9e3db3bfce86908e440f";
  useEffect(() => {
    const getListInformedConsents = async () => {
      try {
        setLoading(true);
        const { status, response } =
          await laboratoryServices.getInformedConsents({
            token: authState.token,
          });
        if (status === 200) {
          setListInformedConsents(response);
        } else {
          setToast(true);
          setToastMessage("Error de carga.");
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    getListInformedConsents();
  }, []);
  const downloadSignatories = async ({ consentId }) => {
    try {
      setLoading(true);
      const { status, response } = await laboratoryServices.downloadSignatories(
        {
          token: authState.user.token,
          consentId,
        }
      );
      setLoading(false);
      if (status === 200) {
        var blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "signatories.xlsx";
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
    } catch (error) {
      setLoading(false);
      alert("Ha ocurrido un error.");
    }
  };
  return (
    <>
      {" "}
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.root}>
        {loading && <Loader loading={true} />}
        <Toast
          open={toast}
          message={toastMessage}
          close={() => setToast(false)}
        />
        <Grid item xs={12} className={classes.content}>
          <Container maxWidth={false}>
            <SimpleToolbar
              hideExport={true}
              isOpen={isOpen}
              setIsOpen={(value) => setIsOpen(value)}
              noSearchBar
            />
          </Container>
          <Container maxWidth="lg" component={"main"}>
            {isMasterAdmin && (
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                mt={2}
                style={{ flexWrap: "wrap", gap: 12 }}
              >
                <ConsentsSearchBar />
                <LinkButton
                  variant="contained"
                  color="secondary"
                  to={{
                    pathname: "/consent/add",
                  }}
                >
                  <Typography
                    component={"span"}
                    style={{ display: "flex", gap: 4, alignItems: "center" }}
                  >
                    <PostAddOutlinedIcon fontSize="small" />
                    Agregar consentimiento
                  </Typography>
                </LinkButton>
              </Box>
            )}
            <CustomTable
              propsTable={{
                id: "consentTable",
                style: { tableLayout: "fixed" },
              }}
            >
              {!listInformedConsents ? (
                <TableBody>
                  <TableRow>
                    <TableCell align="center">No hay resultados </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <>
                  <TableHead>
                    <TableRow>
                      <TableCell>Nombre</TableCell>
                      <TableCell>Dueño</TableCell>
                      <TableCell>Versión</TableCell>
                      <TableCell>Tipo</TableCell>
                      <TableCell>Objetivo</TableCell>
                      <TableCell>Última actualización</TableCell>
                      <TableCell align="right">Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {listInformedConsents.map((doc) => (
                      <TableRow key={doc._id}>
                        <TableCell
                          className={`${classes.cell_content} ${classes.name}`}
                        >
                          <Typography data-label="content" component={"span"}>
                            <Hidden smUp>
                              <Typography
                                component={"span"}
                                style={{ fontWeight: 600 }}
                              >
                                Nombre:
                              </Typography>
                            </Hidden>
                            <Typography component={"span"}>
                              {doc.name}
                            </Typography>
                          </Typography>
                        </TableCell>
                        <TableCell
                          className={`${classes.cell_content} ${classes.name}`}
                        >
                          <Typography data-label="content" component={"span"}>
                            <Hidden smUp>
                              <Typography
                                component={"span"}
                                style={{ fontWeight: 600 }}
                              >
                                Dueño:
                              </Typography>
                            </Hidden>
                            <Typography component={"span"}>
                              {doc.owner === "UNIO"
                                ? "UNIO"
                                : doc.laboratory.name}
                            </Typography>
                          </Typography>
                        </TableCell>
                        <TableCell
                          className={`${classes.cell_content} ${classes.version}`}
                        >
                          <Typography
                            id="version"
                            component={"span"}
                            data-label="content"
                          >
                            <Hidden smUp>
                              <Typography
                                component={"span"}
                                style={{ fontWeight: 600 }}
                              >
                                Versión:
                              </Typography>
                            </Hidden>
                            <Typography component={"span"}>
                              {`${doc.majorVersion}.${doc.minorVersion}`}
                            </Typography>
                          </Typography>
                        </TableCell>
                        <TableCell
                          className={`${classes.cell_content} ${classes.type}`}
                        >
                          <Typography data-label="content" component={"span"}>
                            <Hidden smUp>
                              <Typography
                                component={"span"}
                                style={{ fontWeight: 600 }}
                              >
                                Tipo:
                              </Typography>
                            </Hidden>
                            <Typography component={"span"}>
                              {consentsCaption.type[doc.type]}
                            </Typography>
                          </Typography>
                        </TableCell>
                        <TableCell
                          className={`${classes.cell_content} ${classes.target}`}
                        >
                          <Typography component={"span"} data-label="content">
                            <Hidden smUp>
                              <Typography
                                component={"span"}
                                style={{ fontWeight: 600 }}
                              >
                                Objetivo:
                              </Typography>
                            </Hidden>
                            <Typography component={"span"}>
                              {consentsCaption.target[doc.target]}
                            </Typography>
                          </Typography>
                        </TableCell>

                        <TableCell
                          className={`${classes.cell_content} ${classes.date}`}
                        >
                          <Typography component={"span"} data-label="content">
                            <Hidden smUp>
                              <Typography
                                component={"span"}
                                style={{ fontWeight: 600, lineHeight: 1 }}
                              >
                                <ScheduleRounded />
                              </Typography>
                            </Hidden>
                            <Typography component={"span"}>
                              {moment(doc.updatedAt).format("DD/MM/YYYY")}
                            </Typography>
                          </Typography>
                        </TableCell>
                        <TableCell
                          align="right"
                          className={classes.cell_actions}
                        >
                          <Box component={"span"} className={classes.actions}>
                            {isMasterAdmin && (
                              <Tooltip
                                title="Editar consentimiento"
                                placement="top"
                                arrow
                              >
                                <LinkButton
                                  variant="outlined"
                                  color="default"
                                  to={{
                                    pathname: `/consent/update/${doc._id}`,
                                  }}
                                >
                                  <CreateOutlined fontSize="small" />
                                </LinkButton>
                              </Tooltip>
                            )}
                            <Tooltip
                              title="Ver consentimiento"
                              placement="top"
                              arrow
                            >
                              <Icon
                                color="secondary"
                                style={{
                                  width: 50,
                                  height: 32,
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <a
                                  style={{ color: "inherit" }}
                                  href={doc.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <Visibility fontSize="small" />
                                </a>
                              </Icon>
                            </Tooltip>
                            {isMasterAdmin && (
                              <Tooltip
                                title="Descargar firmantes"
                                placement="top"
                                arrow
                              >
                                <IconButton
                                  onClick={() =>
                                    downloadSignatories({ consentId: doc._id })
                                  }
                                >
                                  <CloudDownloadRounded />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </>
              )}
            </CustomTable>
          </Container>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    flex: 1,
    minHeight: "100vh",
  },
  cell_content: {
    padding: 4,
    '& span[data-label="content"]': {
      alignItems: "center",
      gap: 4,
      display: "flex",
      justifyContent: "center",
      [theme.breakpoints.down("xs")]: {
        justifyContent: "start",
      },
    },
  },
  name: {
    [theme.breakpoints.down("sm")]: {
      gridColumn: "span 2",
    },
  },
  version: {
    [theme.breakpoints.down("sm")]: {
      gridColumn: 1,
    },
  },
  date: {
    [theme.breakpoints.down("sm")]: {
      gridColumn: 2,
    },
  },
  type: {
    [theme.breakpoints.down("sm")]: {
      gridColumn: 2,
    },
  },
  target: {
    [theme.breakpoints.down("sm")]: {
      gridColumn: 1,
    },
  },
  cell_actions: {
    padding: 4,
    [theme.breakpoints.down("sm")]: {
      gridColumn: "span 2",
      justifyContent: "space-evenly",
    },
  },
  actions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    // [theme.breakpoints.down("sm")]: {
    //   gridColumn: "span 2",
    //   justifyContent: "space-evenly",
    // },
  },
}));
